import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '2.5rem 1.5rem',
  border: `1px solid ${theme.palette.focus30.light}`,
  borderRadius: '1rem'
}));
